module.exports = __webpack_public_path__ + "img/line_idea_lamp.a6e311e5.png";